/**
 * Модуль, который определяет IRI элемента при клике 
 * IRI обеспечивает его связь с элементами коллективной работы
 */
module.exports = function(graph) {
  var linker = {},
    IRI;
  var elementTools = webvowl.util.elementTools();

  linker.handle = function (selectedElement) {
    console.log("linker.js ", selectedElement)
		if (elementTools.isProperty(selectedElement)) {
			IRI = selectedElement.iri();
		} else if (elementTools.isNode(selectedElement)) {
			IRI = selectedElement.iri();
		} else{
      IRI = undefined;
    }
  };

  linker.iri=function(val){
    if (!arguments.length) return IRI;
    IRI=val;
};

  return linker;
};